export function validJournalInteger(value, minimum = 1) {
    return (typeof value === 'string' || typeof value === 'number') && /^\d+$/.test(String(value))
        && Number.isSafeInteger(Number(value)) && Number(value) >= minimum && Number(value) <= 2147483647;
}
